// validations
const _v = {

	required (v) {
		if ((!v) || (v && v.length > 0 && v.trim().length == 0)) return 'Field is required'
		return true
	},

	mobileRequired (v) {
		if ((!v) || (v && v.length > 0 && v.trim().length == 0)) return 'Mobile Number is required'
		return true
	},

	mobile (v) {
		if (v && v.length > 0 && v.trim().length !== 10) return 'Mobile Number must be 10 digits'
		return true
	},

	emailRequired (v) {
		if ((!v) || (v && v.length > 0 && v.trim().length == 0)) return 'Email is required'
		return true
	},

	email (v) {
		if (!v) return true
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
	}

}

// rules
const rules = {
	required: [_v.required],
	mobile: [_v.mobile],
	mobileRequired: [_v.mobileRequired, _v.mobile],
	email: [_v.email],
	emailRequired: [_v.emailRequired, _v.email],
}

export default rules
